import * as yup from "yup"
import type { Document } from "../../types"

export function initialValuesDocument(document?: Document | undefined) {
  if (document) {
    return document
  }
  return {
    title: "",
    description: "",
    record_media_types: [],
    genres: [],
    event_types: [],
    authors: [],
    editors: [],
    producers: [],
    archives: [],
    collections: [],
    year: undefined,
    date_generic: undefined,
    event_year: undefined,
    source_urls: [],
    embed_url: '',
    municipalities: [],
    draft: false,
  }
}

export function validationSchemaDocument() {
  return yup.object().shape({
    title: yup.string().required("Campo obbligatorio"),
    description: yup.string().required("Campo obbligatorio"),
    record_media_types: yup
      .array()
      .of(yup.string())
      .min(1, "Seleziona almeno una tipologia")
      .required("Campo obbligatorio"),
    genres: yup.array().of(yup.number()),
    event_types: yup.array().of(yup.string()).required("Campo obbligatorio").min(1, "Seleziona almeno un tipo di evento"),
  })
}
